module.exports = __webpack_public_path__ + "static/media/das-erste_vert.4499350c.svg";